import React from "react";
import UiInput from '../../../../_uiMocks/_uiComponents/UiInput';
import { UiEditor } from "../../../../_uiComponents/common/form/UiStyledInputs";
import { UiInputGroupWr } from "../../../../_uiComponents/common/form/UiInputComponents";
import { Grid } from "@mui/material";
import { UiIconButton } from "../../../../_uiComponents/common/form/UiButton";
import { UiSaveIcon } from "../../../../../styles/images/svg/UiSaveIcon";
// import UiFileUpload from '../../../../_uiComponents/common/form/UiCropFileUpload';

export const CreateMarcomsForm = () => {

    return (
        <>
            <UiInputGroupWr title="Setup Header Content">
                <Grid container spacing={1} mt={1} mx="5px">
                    <Grid container>
                        <Grid item xs="12" md="8" lg="6">
                            <UiInput
                                label="Title"
                                placeholder="Max 50 characters" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs="12" md="8" lg="6">
                            <UiInput
                                label="Description"
                                placeholder="Max 150 characters"
                                multiline={true}
                                minRows={3}
                                maxRows={5} />
                        </Grid>
                    </Grid>
                    {/* <Grid container>
                        <Grid item xs="12" md="8" lg="6">
                            <UiFileUpload width="423" height="256" label="Header Image 1"  
                            uploadSize="Min. image size 380px x 230px"/>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs="12" md="8" lg="6">
                            <UiFileUpload width="312" height="256" label="Header Image 2" 
                            uploadSize="Min. image size 280px x 230px"/>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs="12" md="9" lg="9">
                            <UiFileUpload width="756" height="140" label="Header Image 3" 
                            uploadSize="Min. image size 680px x 125px" />
                        </Grid>
                    </Grid> */}
                </Grid>
            </UiInputGroupWr>

            <UiInputGroupWr title="Campaign Carousel Image Setup">
                <Grid container>
                    {/* <Grid item xs="12" md="8" lg="6">
                        <UiFileUpload width="467" height="256" label="Campaign Carousel Image" 
                        uploadSize="Min. image size 420px x 230px" />
                    </Grid> */}
                </Grid>
            </UiInputGroupWr>

            <UiInputGroupWr title="Setup Overview Content">
                <UiEditor title="Description" />
                {/* <Grid container>
                    <Grid item xs="12" md="8" lg="6">
                        <UiFileUpload width="273" height="273" label="Overview Image 1" 
                        uploadSize="Min. image size 245px x 245px" />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs="12" md="8" lg="6">
                        <UiFileUpload width="273" height="273" label="Overview Image 2" 
                        uploadSize="Min. image size 245px x 245px"/>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs="12" md="8" lg="6">
                        <UiFileUpload width="273" height="273" label="Overview Image 3" 
                        uploadSize="Min. image size 245px x 245px"/>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs="12" md="8" lg="6">
                        <UiFileUpload width="273" height="273" label="Overview Image 4" 
                        uploadSize="Min. image size  245px x 245px"/>
                    </Grid>
                </Grid> */}


            </UiInputGroupWr>

            <UiInputGroupWr title="Setup Features Content">
                <UiEditor title="description" />
                {/* <UiFileUpload width="801" height="612" label="Features Image"  */}
                {/* uploadSize="Min. image size 720px x 550px" /> */}
            </UiInputGroupWr>

            <UiInputGroupWr title="Setup Equipment Level Content">
                <Grid container mx="5px" mt={1} spacing={2} className="sbt-styled-input__group-wr-grid">
                    <Grid container >
                        <Grid item xs="12" md="8" lg="6">
                            <UiInput
                                label="Description"
                                placeholder="Max 200 characters"
                                multiline={true}
                                minRows={3}
                                maxRows={5} />
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid xs="12" md="8" lg="6">
                            <UiInput
                                label="Range"
                                placeholder="Max 25 characters" />
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid xs="12" md="8" lg="6">
                            <UiInput
                                label="Core"
                                placeholder="Max 25 characters" />
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid xs="12" md="8" lg="6">
                            <UiInput
                                label="Ultimate"
                                placeholder="Max 25 characters" />
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid xs="12" md="8" lg="6">
                            <UiInput
                                label="Plus"
                                placeholder="Max 25 characters" />
                        </Grid>
                    </Grid>
                </Grid>
            </UiInputGroupWr>

            <UiIconButton
                icon={<UiSaveIcon />}
                size='large'
                name="Save" />
        </>
    )
}